import type { TypeNavNode, TypeNavTrail } from '@/types/ui/types.ui.navigation';
import navigationFlatten from './navigation.flatten';

export function navigationFindById(nodes: TypeNavNode[], id: string): TypeNavTrail | null {
    return navigationFlatten(nodes).find((entry) => entry.node.id === id) ?? null;
}

export function navigationResolve(nodes: TypeNavNode[], pathname: string): TypeNavTrail | null {
    const path = pathname === '/' ? '/overview' : pathname;

    return navigationFlatten(nodes)
        .filter(({ node }) => path === node.path || path.startsWith(`${node.path}/`))
        .sort((a, b) => b.node.path.length - a.node.path.length)[0] ?? null;
}

export function navigationContains(node: TypeNavNode, pathname: string): boolean {
    return pathname === node.path || pathname.startsWith(`${node.path}/`);
}
